import { render, staticRenderFns } from "./VChangePassword.vue?vue&type=template&id=8aeb865e&scoped=true&"
import script from "./VChangePassword.vue?vue&type=script&lang=js&"
export * from "./VChangePassword.vue?vue&type=script&lang=js&"
import style0 from "./VChangePassword.vue?vue&type=style&index=0&id=8aeb865e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aeb865e",
  null
  
)

export default component.exports